export default {
  flipsLastYear: null,
  flipsNextYear: null,
  averagePurchasePrice: null,
  averageRehabSpend: null,
  averageSalePrice: null,
  averageDaysHeld: null,
  managesProperty: null,
  propertyManager: null,
  rentalManagementCourseComplete: null,
  rentalManagementCourseCompleteDate: null,
  rentalManagementCourseName: null,
  rentalOwned: null,
  rentalManaged: null,
  averageRentalPurchasePrice: null,
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/real_estate/resources/realEstate.js